import React, { PropTypes } from 'react';
import styled from 'styled-components';

const StyledButtonIcognito = styled.button`
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  font: inherit;
  outline: 0;
  padding: 0;
  text-transform: inherit;

  ${props => props.fullWidth && `
    width: 100%;
  `}

  &::-moz-focus-inner,
    border: 0;
    padding: 0;
  }
`;

const ButtonIcognito = props => <StyledButtonIcognito {...props} />;

ButtonIcognito.propTypes = {
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  type: PropTypes.string,
};

ButtonIcognito.defaultProps = {
  type: 'button',
};

export default ButtonIcognito;



// WEBPACK FOOTER //
// ./src/components/common/ButtonIcognito.js